<template>
    <div>
        <app-tabela
            :itens="historicosExclusoes"
            :campos="camposTabelaHistorico"
            :bordered="false"
            :small="false"
        >
            <template slot="statusMomentoExclusao" slot-scope="data">
                <b-badge :variant="obterClasseCorStatus(data.statusMomentoExclusao)">
                    {{ obterDescricaoStatusBoletimMedicao(data.statusMomentoExclusao) }}
                </b-badge>
            </template>
            <template slot="dataExclusao" slot-scope="data">
                {{ data.dataExclusao | toDateTime }}
            </template>
            <template slot="dataCriacaoBM" slot-scope="data">
                {{ data.dataCriacaoBM | toDate }}
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BoletimMedicaoServicos from "./BoletimMedicaoServicos";
import { statusBoletinsMedicao, obterDescricaoStatusBoletimMedicao } from './BoletimMedicao.js';

export default {
    props: {
        contrato: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            statusBoletinsMedicao: statusBoletinsMedicao,
            historicosExclusoes: [],
            camposTabelaHistorico: [
                { key: 'numeroBM', label: 'BM', filterable: true, sortable: true, tdClass: 'text-nowrap' },
                { key: 'dataCriacaoBM', label: 'Data Criação', filterable: true, sortable: true, tdClass: 'text-nowrap' },
                { key: 'usuarioCriadorBM', label: 'Criado Por', filterable: true, sortable: true, tdClass: 'text-nowrap' },
                { key: 'statusMomentoExclusao', label: 'Status no Momento', filterable: true, sortable: true, tdClass: 'text-nowrap' },
                { key: 'dataExclusao', label: 'Data Exclusão', filterable: true, sortable: true, tdClass: 'text-nowrap' },
                { key: 'usuarioExclusao', label: 'Excluído Por', filterable: true, sortable: true, tdClass: 'text-nowrap' }
            ]
        }
    },

    methods: {
        obterDescricaoStatusBoletimMedicao,

        obterHistoricoExclusoes() {
            if (!this.contrato) return;
            BoletimMedicaoServicos.obterHistoricoExclusoesBM(this.contrato.contratoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        this.historicosExclusoes = response.data;
                    }
                });
        },

        obterClasseCorStatus(status) {
            let situacao = this.statusBoletinsMedicao.find(s => s.id === status)
            return situacao ? situacao.classeCor : ''
        },
    },

    created() {
        this.obterHistoricoExclusoes();
    },
}
</script>
